import { render } from "./WelcomeView.vue?vue&type=template&id=a9e05c0e"
const script = {}

import "./WelcomeView.vue?vue&type=style&index=0&id=a9e05c0e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__